var Header = /** @class */ (function () {
    function Header() {
        this.init();
        this.pageDetection();
    }
    Header.prototype.init = function () {
        this.header = document.querySelector('.header');
        this.body = document.body;
        this.document = document.documentElement;
        this.mainMenuItems = document.querySelectorAll('.header-navigation .menu > li.menu-item');
        this.secondaryMenu = document.querySelector('.secondary-menu');
        this.lastScroll = 0;
        this.headerTopPos = window.getComputedStyle(this.header, null).getPropertyValue("--header-pos");
        this.attachListeners();
        //this.tests();
        this.accessibilityListener();
    };
    Header.prototype.accessibilityListener = function () {
        var _this = this;
        var currentItem;
        var nextItem;
        var lastItem = this.mainMenuItems[this.mainMenuItems.length - 1];
        // Loop main menu items
        this.mainMenuItems.forEach(function (item, key) {
            // If menu item has children
            if (item.classList.contains('menu-item-has-children')) {
                // Listen for keydown events
                item.addEventListener('keydown', function (event) {
                    var itemId = item.getAttribute('id');
                    var submenu = _this.secondaryMenu.querySelector("[data-menu-parent=".concat(itemId, "]"));
                    var submenuItems = submenu.querySelectorAll('a');
                    // first item in dropdown list
                    var firstSubmenuItem = submenuItems[0];
                    // last item in dropdown list
                    var lastSubmenuItem = submenuItems[submenuItems.length - 1];
                    var moveBackwards = false; // if using tab + shift to go back
                    // Moving forward - toggle dropdown list
                    if (event.key === 'Tab' && !event.shiftKey) {
                        _this.header.classList.add('active');
                        item.classList.add('active');
                        currentItem = item; // current main menuItem
                        // if not last item in main menu
                        if (key < _this.mainMenuItems.length - 1) {
                            nextItem = _this.mainMenuItems[key + 1]; // next main menuItem
                        }
                        else {
                            nextItem = _this.mainMenuItems[0]; // first main menuItem
                        }
                        submenu.classList.add('active');
                        // set focus to first link in submenu
                        submenu.querySelector('a').focus();
                    }
                    // Listen for keydown events on first submenu item
                    firstSubmenuItem.addEventListener('keydown', function (event) {
                        if (event.key === 'Tab' && event.shiftKey) {
                            // if tab + shift is pressed - moving backwards
                            moveBackwards = true;
                        }
                        else if (event.key === 'Tab' && !event.shiftKey) {
                            // if only tab is pressed - moving forwards
                            moveBackwards = false;
                        }
                    });
                    // Listen for focusout events on first submenu item
                    firstSubmenuItem.addEventListener('focusout', function (event) {
                        if (moveBackwards) {
                            // if moving backwards - set focus to main menu item
                            submenu.classList.remove('active');
                            currentItem.classList.remove('active');
                            _this.header.classList.remove('active');
                            item.querySelector('a').focus();
                            moveBackwards = false; // set moving backwards to false
                        }
                    });
                    // Listen for keydown events on last submenu item
                    lastSubmenuItem.addEventListener('keydown', function (event) {
                        if (event.key === 'Tab' && !event.shiftKey) {
                            // if tab is pressed - moving forwards
                            moveBackwards = false;
                        }
                        else if (event.key === 'Tab' && event.shiftKey) {
                            // if tab + shift is pressed - moving backwards
                            moveBackwards = true;
                        }
                    });
                    // Listen for focusout events on last submenu item
                    lastSubmenuItem.addEventListener('focusout', function (event) {
                        if (!moveBackwards) {
                            // if moving forwards - set focus to next main menu item & close dropdown
                            item.classList.remove('active');
                            submenu.classList.remove('active');
                            _this.header.classList.remove('active');
                            nextItem.querySelector('a').focus();
                        }
                        else {
                            // if moving backwards - set reset move backwards
                            moveBackwards = false;
                        }
                    });
                });
            }
        });
    };
    Header.prototype.pageDetection = function () {
        // set page cookie based on template - determines which header to use for page
        var main = document.querySelector('main');
        if (main && main.hasAttribute('data-page')) {
            var page = main.getAttribute('data-page');
            if (page === 'riga-wood') {
                document.cookie = 'lf-rigawood=true;path=/';
            }
            else if (page === 'lf') {
                document.cookie = 'lf-rigawood=false;path=/';
            }
        }
    };
    Header.prototype.attachListeners = function () {
        var _this = this;
        window.addEventListener('scroll', function () {
            var maxHeaderPosDown = -158;
            var maxHeaderPosUp = -63;
            if (_this.header.style.getPropertyValue('--header-pos')) {
                _this.headerTopPos = _this.header.style.getPropertyValue('--header-pos');
            }
            else {
                _this.headerTopPos = window.getComputedStyle(_this.header, null).getPropertyValue("--header-pos");
            }
            if (_this.lastScroll > _this.document.scrollTop) {
                var newTopPos = Math.min(maxHeaderPosUp, parseInt(_this.headerTopPos) + 3);
                if (newTopPos <= 0) {
                    _this.header.style.setProperty('--header-pos', maxHeaderPosUp + 'px');
                }
            }
            else {
                if (_this.document.scrollTop > 190) {
                    var newTopPos = Math.max(maxHeaderPosDown, parseInt(_this.headerTopPos) - 3);
                    _this.header.style.setProperty('--header-pos', maxHeaderPosDown + 'px');
                }
            }
            _this.lastScroll = _this.document.scrollTop;
        });
    };
    return Header;
}());
export default Header;
